import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'mapfre-auditmap/src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { CacheService } from 'mapfre-auditlib';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class BusinessService {

  className = 'BusinessService';

  constructor(private http: HttpClient, private cacheService: CacheService) { }

  // external-businesses

  getAllExternalBusiness(cache = true, cacheKey = "allExternalBusiness"): Observable<any[]> | any {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey);
    } else {
      let observable = this.http.get<any[]>(environment.base_URL + "/external-companies").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  newExternalBusiness(business) {
    return this.http.post(environment.base_URL + "/external-companies", business)
  }

  updateExternalBusiness(business, id) {
    return this.http.put(environment.base_URL + `/external-companies/${id}`, business)
  }

}
